export const comics = [
  {
    id: "1",
    title: "剑尊归来",
    altTitle: "Swordmaster Returns",
    author: "李东旭",
    artist: "金泰亨",
    category: "热血",
    subcategory: "武侠",
    status: "连载中",
    rating: 9.6,
    views: "1280万",
    description: "一代剑尊林凡在渡劫失败后，灵魂穿越回少年时代。带着前世的记忆与剑道领悟，他决心弥补所有遗憾，守护曾经失去的一切。这一次，他不再是孤高的剑尊，而是要成为真正的强者，踏平一切阻碍。",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20warrior%20holding%20sword%20in%20ancient%20Chinese%20martial%20arts%20setting%2C%20dramatic%20lighting%2C%20warm%20orange%20and%20red%20tones%2C%20clean%20illustration%20style%2C%20manga%20cover%20art%2C%20dynamic%20pose%2C%20floating%20cherry%20blossoms%2C%20soft%20gradient%20background&width=600&height=800&seq=comic-cover-01&orientation=portrait",
    chapters: [
      { num: 128, title: "巅峰对决", date: "2026-07-06", isNew: true },
      { num: 127, title: "暗流涌动", date: "2026-07-03", isNew: true },
      { num: 126, title: "破茧成蝶", date: "2026-06-30", isNew: false },
      { num: 125, title: "风云再起", date: "2026-06-27", isNew: false },
      { num: 124, title: "绝地反击", date: "2026-06-24", isNew: false },
      { num: 123, title: "暗影逼近", date: "2026-06-21", isNew: false },
      { num: 122, title: "剑意通明", date: "2026-06-18", isNew: false },
      { num: 121, title: "生死一线", date: "2026-06-15", isNew: false },
      { num: 120, title: "破晓时分", date: "2026-06-12", isNew: false },
      { num: 119, title: "暗夜降临", date: "2026-06-09", isNew: false },
    ],
    tags: ["重生", "武侠", "热血", "战斗", "逆袭"],
    updateDay: "每周一、四更新",
  },
  {
    id: "2",
    title: "我的ID是江南美人",
    altTitle: "My ID is Gangnam Beauty",
    author: "淇萌",
    artist: "淇萌",
    category: "恋爱",
    subcategory: "校园",
    status: "已完结",
    rating: 9.3,
    views: "2560万",
    description: "从小因外貌被嘲笑的姜美来，通过整容手术获得了全新的面貌，进入大学后渴望开启新的人生。然而，她发现真正的美丽并非来自外表，而是来自内心的自信与成长。一段关于自我认同与真爱的校园故事就此展开。",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20beautiful%20female%20college%20student%20in%20spring%20campus%2C%20warm%20pink%20and%20peach%20tones%2C%20romantic%20illustration%20style%2C%20cherry%20blossom%20petals%20drifting%2C%20soft%20lighting%2C%20manga%20cover%20art%2C%20clean%20gradient%20background&width=600&height=800&seq=comic-cover-02&orientation=portrait",
    chapters: [
      { num: 96, title: "最终话：真正的美丽", date: "2025-12-25", isNew: false },
      { num: 95, title: "告白时刻", date: "2025-12-18", isNew: false },
      { num: 94, title: "心中的答案", date: "2025-12-11", isNew: false },
      { num: 93, title: "不再逃避", date: "2025-12-04", isNew: false },
      { num: 92, title: "温暖的拥抱", date: "2025-11-27", isNew: false },
      { num: 91, title: "真相大白", date: "2025-11-20", isNew: false },
      { num: 90, title: "她的选择", date: "2025-11-13", isNew: false },
      { num: 89, title: "突如其来的告白", date: "2025-11-06", isNew: false },
      { num: 88, title: "青春的悸动", date: "2025-10-30", isNew: false },
      { num: 87, title: "重新开始", date: "2025-10-23", isNew: false },
    ],
    tags: ["校园", "恋爱", "成长", "治愈", "整容"],
    updateDay: "已完结",
  },
  {
    id: "3",
    title: "全知读者视角",
    altTitle: "Omniscient Reader",
    author: "SingNsong",
    artist: "Sleepy-C",
    category: "奇幻",
    subcategory: "穿越",
    status: "连载中",
    rating: 9.8,
    views: "3890万",
    description: "金独子是一个普通上班族，唯一的爱好是阅读一部连载了十年的网络小说《在灭亡的世界中生存的三种方法》。当小说完结那天，他意外发现小说中的世界成为了现实，而他作为唯一的读者，掌握了这个世界的所有秘密。",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20young%20man%20in%20apocalyptic%20urban%20setting%2C%20dramatic%20cool%20blue%20and%20warm%20orange%20contrast%20lighting%2C%20fantasy%20illustration%20with%20ancient%20constellation%20symbols%2C%20manga%20cover%20art%2C%20dynamic%20composition%2C%20clean%20illustration&width=600&height=800&seq=comic-cover-03&orientation=portrait",
    chapters: [
      { num: 215, title: "最后的星座", date: "2026-07-06", isNew: true },
      { num: 214, title: "幕后黑手", date: "2026-07-04", isNew: true },
      { num: 213, title: "真相的碎片", date: "2026-07-02", isNew: false },
      { num: 212, title: "新的盟友", date: "2026-06-30", isNew: false },
      { num: 211, title: "决断之时", date: "2026-06-28", isNew: false },
      { num: 210, title: "远古的呼唤", date: "2026-06-26", isNew: false },
      { num: 209, title: "命运的分岔", date: "2026-06-24", isNew: false },
      { num: 208, title: "光与暗的交汇", date: "2026-06-22", isNew: false },
      { num: 207, title: "王的试炼", date: "2026-06-20", isNew: false },
      { num: 206, title: "星之指引", date: "2026-06-18", isNew: false },
    ],
    tags: ["穿越", "奇幻", "系统", "生存", "星座"],
    updateDay: "每周二、五、日更新",
  },
  {
    id: "4",
    title: "恶女的重生",
    altTitle: "Rebirth of the Villainess",
    author: "草莓味布丁",
    artist: "月光工作室",
    category: "恋爱",
    subcategory: "宫廷",
    status: "连载中",
    rating: 9.4,
    views: "1620万",
    description: "贵族小姐艾琳娜在20岁生日那天，发现自己只是一本小说中的恶毒女配。为摆脱注定悲惨的命运，她决定彻底改写自己的人生剧本。不再做任何人的陪衬，这一世，她要做自己的主角。",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20elegant%20noblewoman%20in%20European%20royal%20palace%20ballroom%2C%20warm%20golden%20and%20rose%20pink%20tones%2C%20romantic%20historical%20fantasy%20illustration%2C%20beautiful%20dress%2C%20crystal%20chandelier%2C%20manga%20cover%20art%2C%20soft%20glowing%20background&width=600&height=800&seq=comic-cover-04&orientation=portrait",
    chapters: [
      { num: 89, title: "命运之日", date: "2026-07-05", isNew: true },
      { num: 88, title: "王子的决心", date: "2026-07-02", isNew: false },
      { num: 87, title: "舞会风云", date: "2026-06-29", isNew: false },
      { num: 86, title: "暗藏杀机", date: "2026-06-26", isNew: false },
      { num: 85, title: "真心的证明", date: "2026-06-23", isNew: false },
      { num: 84, title: "阴谋揭穿", date: "2026-06-20", isNew: false },
      { num: 83, title: "意外的救星", date: "2026-06-17", isNew: false },
      { num: 82, title: "花园密谈", date: "2026-06-14", isNew: false },
      { num: 81, title: "深夜来客", date: "2026-06-11", isNew: false },
      { num: 80, title: "茶会风波", date: "2026-06-08", isNew: false },
    ],
    tags: ["宫廷", "重生", "女配", "逆袭", "恋爱"],
    updateDay: "每周三、六更新",
  },
  {
    id: "5",
    title: "我独自升级",
    altTitle: "Solo Leveling",
    author: "Chugong",
    artist: "DUBU",
    category: "热血",
    subcategory: "异能",
    status: "已完结",
    rating: 9.9,
    views: "8920万",
    description: "十年前，世界突然出现了连接异次元的「门」，随之觉醒的猎人们肩负起对抗魔物的使命。E级猎人成振宇，被称为人类最弱兵器，在一次几乎全军覆没的地下城探索中，意外获得了「系统」的力量。从此，他将一步步成为人类最强的存在。",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20dark%20haired%20hunter%20with%20purple%20glowing%20eyes%20in%20urban%20dungeon%20setting%2C%20dramatic%20shadow%20and%20neon%20lighting%2C%20action%20fantasy%20illustration%2C%20monster%20shadows%2C%20manga%20cover%20art%2C%20intense%20atmosphere&width=600&height=800&seq=comic-cover-05&orientation=portrait",
    chapters: [
      { num: 179, title: "最终章：王的归来", date: "2024-08-15", isNew: false },
      { num: 178, title: "时间的尽头", date: "2024-08-08", isNew: false },
      { num: 177, title: "最后的战斗", date: "2024-08-01", isNew: false },
      { num: 176, title: "宿命的对决", date: "2024-07-25", isNew: false },
      { num: 175, title: "影之军团", date: "2024-07-18", isNew: false },
      { num: 174, title: "觉醒之力", date: "2024-07-11", isNew: false },
      { num: 173, title: "君主的意志", date: "2024-07-04", isNew: false },
      { num: 172, title: "胜利的曙光", date: "2024-06-27", isNew: false },
      { num: 171, title: "背水一战", date: "2024-06-20", isNew: false },
      { num: 170, title: "最后的防线", date: "2024-06-13", isNew: false },
    ],
    tags: ["异能", "升级", "系统", "战斗", "暗影"],
    updateDay: "已完结",
  },
  {
    id: "6",
    title: "她的私密生活",
    altTitle: "Her Private Life",
    author: "金成妍",
    artist: "夏日漫画",
    category: "恋爱",
    subcategory: "职场",
    status: "连载中",
    rating: 9.1,
    views: "980万",
    description: "白天是美术馆的专业策展人，晚上却是偶像团体的狂热站姐——成德美过着完美的双重生活。直到新任馆长Ryan Gold的出现，这个秘密开始逐渐瓦解。而这位看似冷酷的馆长，似乎也有着自己不为人知的一面。",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20elegant%20woman%20in%20art%20gallery%20with%20paintings%2C%20warm%20ivory%20and%20soft%20brown%20tones%2C%20romantic%20comedy%20illustration%2C%20professional%20setting%2C%20manga%20cover%20art%2C%20clean%20soft%20gradient%20background&width=600&height=800&seq=comic-cover-06&orientation=portrait",
    chapters: [
      { num: 72, title: "坦白之夜", date: "2026-07-05", isNew: true },
      { num: 71, title: "展览大成功", date: "2026-07-01", isNew: false },
      { num: 70, title: "危机公关", date: "2026-06-27", isNew: false },
      { num: 69, title: "秘密曝光", date: "2026-06-23", isNew: false },
      { num: 68, title: "心动的瞬间", date: "2026-06-19", isNew: false },
      { num: 67, title: "艺术家的告白", date: "2026-06-15", isNew: false },
      { num: 66, title: "意外的相遇", date: "2026-06-11", isNew: false },
      { num: 65, title: "深夜加班", date: "2026-06-07", isNew: false },
      { num: 64, title: "新的委托", date: "2026-06-03", isNew: false },
      { num: 63, title: "团队磨合", date: "2026-05-30", isNew: false },
    ],
    tags: ["职场", "恋爱", "喜剧", "追星", "双向暗恋"],
    updateDay: "每周四更新",
  },
  {
    id: "7",
    title: "神之塔",
    altTitle: "Tower of God",
    author: "SIU",
    artist: "SIU",
    category: "奇幻",
    subcategory: "冒险",
    status: "连载中",
    rating: 9.7,
    views: "5230万",
    description: "只要登顶就能获得一切——财富、荣耀、权力、力量，乃至成为神。二十五夜只是一个普通的少年，为了追寻唯一的朋友蕾哈尔，他打开了通往神之塔的大门。在这个充满试炼与背叛的神秘塔中，他必须不断攀登，揭开塔的终极秘密。",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20mysterious%20boy%20climbing%20giant%20tower%20in%20fantasy%20world%2C%20warm%20golden%20and%20deep%20teal%20tones%2C%20epic%20adventure%20illustration%2C%20floating%20platforms%2C%20manga%20cover%20art%2C%20celestial%20atmosphere&width=600&height=800&seq=comic-cover-07&orientation=portrait",
    chapters: [
      { num: 612, title: "最终的考验", date: "2026-07-07", isNew: true },
      { num: 611, title: "王的归来", date: "2026-07-04", isNew: true },
      { num: 610, title: "破碎的王座", date: "2026-07-01", isNew: false },
      { num: 609, title: "远古的契约", date: "2026-06-28", isNew: false },
      { num: 608, title: "联盟与背叛", date: "2026-06-25", isNew: false },
      { num: 607, title: "公主的决心", date: "2026-06-22", isNew: false },
      { num: 606, title: "隐藏的楼层", date: "2026-06-19", isNew: false },
      { num: 605, title: "试炼开始", date: "2026-06-16", isNew: false },
      { num: 604, title: "新的旅程", date: "2026-06-13", isNew: false },
      { num: 603, title: "久别重逢", date: "2026-06-10", isNew: false },
    ],
    tags: ["冒险", "奇幻", "试炼", "友情", "塔"],
    updateDay: "每周一更新",
  },
  {
    id: "8",
    title: "不良教师",
    altTitle: "Delinquent Teacher",
    author: "朴成俊",
    artist: "极光工作室",
    category: "热血",
    subcategory: "校园",
    status: "连载中",
    rating: 9.0,
    views: "720万",
    description: "前不良少年金志勋为了兑现对已故老师的承诺，成为一名高中教师。然而，他被分配到的班级全是学校最令人头疼的问题学生。面对这群被社会放弃的少年，他用自己独特的教育方式，帮助每个学生找回人生的方向。",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20young%20teacher%20in%20classroom%20with%20students%2C%20warm%20sunlight%20through%20windows%2C%20inspirational%20school%20life%20illustration%2C%20manga%20cover%20art%2C%20clean%20warm%20tone%20background&width=600&height=800&seq=comic-cover-08&orientation=portrait",
    chapters: [
      { num: 56, title: "毕业典礼", date: "2026-07-04", isNew: true },
      { num: 55, title: "最后的课堂", date: "2026-06-28", isNew: false },
      { num: 54, title: "每个孩子的梦想", date: "2026-06-21", isNew: false },
      { num: 53, title: "家访风波", date: "2026-06-14", isNew: false },
      { num: 52, title: "球场的约定", date: "2026-06-07", isNew: false },
    ],
    tags: ["校园", "热血", "教师", "成长", "治愈"],
    updateDay: "每周日更新",
  },
  {
    id: "9",
    title: "诡秘之主",
    altTitle: "Lord of Mysteries",
    author: "会说话的肘子",
    artist: "星尘漫画",
    category: "悬疑",
    subcategory: "灵异",
    status: "连载中",
    rating: 9.5,
    views: "2150万",
    description: "周明瑞一觉醒来，发现自己穿越到了蒸汽与机械时代的异世界，成为一个刚被卷入神秘事件的普通人。在这里，非凡之力潜藏于日常之下，22条神之途径通向不可名状的秘密。为了生存，他必须小心翼翼地在这个充满诡秘与危险的世界中行走。",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20mysterious%20figure%20in%20Victorian%20steampunk%20setting%2C%20dark%20amber%20and%20deep%20brown%20tones%2C%20occult%20mystery%20illustration%2C%20clock%20tower%2C%20foggy%20atmosphere%2C%20manga%20cover%20art%2C%20candlelit%20scene&width=600&height=800&seq=comic-cover-09&orientation=portrait",
    chapters: [
      { num: 198, title: "命运之蛇", date: "2026-07-06", isNew: true },
      { num: 197, title: "隐匿贤者", date: "2026-07-03", isNew: true },
      { num: 196, title: "天使的降临", date: "2026-06-30", isNew: false },
      { num: 195, title: "源堡之上", date: "2026-06-27", isNew: false },
      { num: 194, title: "非凡特性", date: "2026-06-24", isNew: false },
      { num: 193, title: "密修会", date: "2026-06-21", isNew: false },
      { num: 192, title: "序列的奥秘", date: "2026-06-18", isNew: false },
      { num: 191, title: "灰雾之上", date: "2026-06-15", isNew: false },
    ],
    tags: ["悬疑", "灵异", "穿越", "蒸汽朋克", "序列"],
    updateDay: "每周三、六更新",
  },
  {
    id: "10",
    title: "社内相亲",
    altTitle: "Business Proposal",
    author: "海花",
    artist: "海花",
    category: "恋爱",
    subcategory: "职场",
    status: "已完结",
    rating: 9.2,
    views: "3450万",
    description: "食品公司研究员申夏莉替闺蜜去相亲，本想故意搞砸一切，却发现相亲对象竟是自己的公司社长姜泰武。更糟糕的是，社长竟然对她产生了兴趣，并提出以结婚为前提的交往。一场始于谎言的恋爱喜剧就此拉开帷幕。",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20couple%20in%20elegant%20restaurant%20blind%20date%20scene%2C%20warm%20romantic%20champagne%20and%20candle%20lighting%2C%20romantic%20comedy%20illustration%2C%20manga%20cover%20art%2C%20soft%20golden%20background&width=600&height=800&seq=comic-cover-10&orientation=portrait",
    chapters: [
      { num: 112, "title": "最终话：真爱告白", "date": "2025-10-10", "isNew": false },
      { num: 111, "title": "婚礼进行曲", "date": "2025-10-03", "isNew": false },
      { num: 110, "title": "家人的祝福", "date": "2025-09-26", "isNew": false },
      { num: 109, "title": "危机解除", "date": "2025-09-19", "isNew": false },
      { num: 108, "title": "情敌出现", "date": "2025-09-12", "isNew": false },
    ],
    tags: ["职场", "恋爱", "喜剧", "契约恋爱", "甜宠"],
    updateDay: "已完结",
  },
  {
    id: "11",
    title: "伯爵家的废物",
    altTitle: "Trash of the Count's Family",
    author: "柳岚",
    artist: "PAN4",
    category: "奇幻",
    subcategory: "穿越",
    status: "连载中",
    rating: 9.6,
    views: "1980万",
    description: "金路云穿进了自己读过的小说中，变成了人人唾弃的伯爵家长子——一个被所有人视为废物的角色。但他并不在意他人的眼光，只想在这个世界里过上悠闲的躺平生活。然而，命运的齿轮却不断将他推向风暴的中心。",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20noble%20young%20man%20in%20European%20manor%20library%2C%20warm%20amber%20and%20forest%20green%20tones%2C%20fantasy%20aristocratic%20illustration%2C%20ancient%20books%2C%20manga%20cover%20art%2C%20cozy%20fireplace%20glow&width=600&height=800&seq=comic-cover-11&orientation=portrait",
    chapters: [
      { num: 145, title: "龙之契约", date: "2026-07-06", isNew: true },
      { num: 144, title: "暗黑精灵的密约", date: "2026-07-03", isNew: true },
      { num: 143, title: "北方战线", date: "2026-06-30", isNew: false },
      { num: 142, title: "古代遗迹", date: "2026-06-27", isNew: false },
      { num: 141, title: "魔族的动向", date: "2026-06-24", isNew: false },
    ],
    tags: ["穿越", "奇幻", "贵族", "魔法", "轻松"],
    updateDay: "每周二、五更新",
  },
  {
    id: "12",
    title: "极限职业",
    altTitle: "Extreme Job",
    author: "金民秀",
    artist: "爆笑工坊",
    category: "搞笑",
    subcategory: "日常",
    status: "连载中",
    rating: 9.0,
    views: "1560万",
    description: "五个不同行业的普通人，因为各种离谱的原因走到一起，展开了一段令人捧腹的职场生活。从外卖骑手到殡仪馆化妆师，从游戏代练到宠物殡葬师，每一种职业背后都有着意想不到的搞笑日常。",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20funny%20group%20of%20different%20professionals%20in%20colorful%20uniforms%2C%20bright%20and%20cheerful%20comedy%20illustration%2C%20manga%20cover%20art%2C%20warm%20yellow%20and%20orange%20background&width=600&height=800&seq=comic-cover-12&orientation=portrait",
    chapters: [
      { num: 67, title: "殡仪馆大作战", date: "2026-07-05", isNew: true },
      { num: 66, title: "外卖之神", date: "2026-06-30", isNew: false },
      { num: 65, title: "游戏代练的尊严", date: "2026-06-25", isNew: false },
      { num: 64, title: "宠物殡葬师的一天", date: "2026-06-20", isNew: false },
      { num: 63, title: "五个人的烤肉派对", date: "2026-06-15", isNew: false },
    ],
    tags: ["搞笑", "日常", "职场", "喜剧", "轻松"],
    updateDay: "每周五更新",
  },
];

export const newComics = comics.filter((c) =>
  c.chapters.some((ch) => ch.isNew)
);

export const completedComics = comics.filter((c) => c.status === "已完结");

export const rankedComics = [...comics]
  .sort((a, b) => b.views.replace("万", "") - a.views.replace("万", ""))
  .slice(0, 10);